// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"928px","container-large-width":"1152px"};